export const namespaced = true;

export const state = () => ({
  active: false,
  title: null,
  content: null,
});

export const mutations = {
  setModalData(state, data) {
    if (!data) {
      state.active = false;
      return;
    }

    state.active = true;
    state.title = data.title;
    state.callback = data.callback;
    state.cancelButton = data.cancelButton;
    state.button = data.button;
    state.content = data.content;
  },
};
